import { render, staticRenderFns } from "./age_analyze.vue?vue&type=template&id=47e2ae68&scoped=true&"
import script from "./age_analyze.vue?vue&type=script&lang=js&"
export * from "./age_analyze.vue?vue&type=script&lang=js&"
import style0 from "./age_analyze.vue?vue&type=style&index=0&id=47e2ae68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2ae68",
  null
  
)

export default component.exports